import PropTypes from 'prop-types';
import React from 'react';
import { defineMessages, FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import * as ReduxForm from 'redux-form';
import { decorateWith, withName } from 'helpers/decorator';
import { ConsentMessage } from 'components/Consent/ConsentMessage';
import { ApiError } from 'components/Errors/ApiError';
import { Heading } from 'components/Heading/Heading';
import { Section } from 'components/Section/Section';
import { FacebookForm } from '../forms/FacebookForm';
import { LeadForm } from '../forms/LeadForm';
import { SignupCardCta } from '../forms/SignupCardCta';
import { LEAD_FORM } from '../sagas/lead.saga';
import { FACEBOOK_FORM } from '../sagas/facebook.saga';

const messages = defineMessages({
  horizontalSeparator: {
    id: 'signup-card.lead.horizontal-separator',
    defaultMessage: 'or',
  },
  stepTitle: {
    id: 'signup-card.lead.step-title',
    defaultMessage: 'Enter your email to continue',
  },
});

export const LeadCardUnwrapped = ({
  error,
  hasFacebookSucceeded,
  hasLeadSucceeded,
  hiddenFields,
  intl,
  isFacebookSubmitting,
  isLeadIncomplete,
  isLeadSubmitting,
  onFacebookSuccess,
  onLeadSuccess,
  tag,
  terms,
}) => (
  <div className="card">
    <Section className="SignupCard SignupCard--lead-step">
      {tag && (
        <div className="SignupCard__tag">
          <span>{tag}</span>
        </div>
      )}
      {error && (
        <div className="SignupCard__error">
          <ApiError error={error} />
        </div>
      )}
      <header>
        <Heading className="SignupCard__title">
          <FormattedMessage {...messages.stepTitle} />
        </Heading>
      </header>
      <div className="SignupCard__form">
        <LeadForm formId={LEAD_FORM} hiddenFields={hiddenFields} onSuccess={onLeadSuccess} />
      </div>
      <div className="SignupCard__cta">
        <SignupCardCta
          formId={LEAD_FORM}
          isDisabled={!!(false || hasFacebookSucceeded || hasLeadSucceeded || isFacebookSubmitting || isLeadIncomplete)}
          isSubmitting={!!isLeadSubmitting}
        />
      </div>
      <hr className="SignupCard__form-separator" data-value={intl.formatMessage(messages.horizontalSeparator)} />
      <div className="SignupCard__form">
        <FacebookForm
          hiddenFields={hiddenFields}
          isDisabled={!!(false || hasFacebookSucceeded || hasLeadSucceeded || isLeadSubmitting)}
          onSuccess={onFacebookSuccess}
        />
      </div>
      {terms && (
        <div className="SignupCard__terms">
          <ConsentMessage className="SignupCard__terms__text" message={terms} />
        </div>
      )}
    </Section>
  </div>
);

LeadCardUnwrapped.propTypes = {
  error: ApiError.propTypes.error,
  hiddenFields: PropTypes.object,
  hasFacebookSucceeded: PropTypes.bool,
  hasLeadSucceeded: PropTypes.bool,
  intl: intlShape,
  isFacebookSubmitting: PropTypes.bool,
  isLeadIncomplete: PropTypes.bool,
  isLeadSubmitting: PropTypes.bool,
  onFacebookSuccess: PropTypes.func.isRequired,
  onLeadSuccess: PropTypes.func.isRequired,
  tag: PropTypes.node,
  terms: PropTypes.string,
};

const mapStateToProps = state => ({
  error: ReduxForm.getFormError(LEAD_FORM)(state) || ReduxForm.getFormError(FACEBOOK_FORM)(state),
  hasFacebookSucceeded: ReduxForm.hasSubmitSucceeded(FACEBOOK_FORM)(state),
  hasLeadSucceeded: ReduxForm.hasSubmitSucceeded(LEAD_FORM)(state),
  isFacebookSubmitting: ReduxForm.isSubmitting(FACEBOOK_FORM)(state),
  isLeadIncomplete: ReduxForm.isInvalid(LEAD_FORM)(state),
  isLeadSubmitting: ReduxForm.isSubmitting(LEAD_FORM)(state),
  terms: (ReduxForm.getFormValues(FACEBOOK_FORM)(state) || {}).terms,
});

export const LeadCard = decorateWith(injectIntl, connect(mapStateToProps), withName('LeadCard'))(LeadCardUnwrapped);
